export enum MixPanelStatus {
  Error = 'Error',
  Success = 'Success'
}

export enum MixPanelEvent {
  PageLanded = 'Page Landed',
  TradeClicked = 'Trade Clicked',
  ReferralCode = 'Referral - Code',
  WalletConnected = 'Wallet Connected',
  OnramperSuccess = 'OnRamper Success',
  BridgeInitiated = 'Bridge - Initiated',
  BridgeCompleted = 'Bridge - Completed',
  WalletDisconnected = 'Wallet Disconnected',
  UtmStockTwitsToast = 'Utm - Stock Twits Toast',
  UtmStockTwitsBanner = 'Utm - Stock Twits Banner',
  ChangeSelectedLanguage = 'Change Selected Language',
  WalletConnectInitiated = 'Wallet Connect Initiated',
  InitialSelectedLanguage = 'Initial Selected Language',
  OnboardingUserDoesntTrade = 'Onboarding - User Doesnt Trade',
  OnboardingUserWithNoAssets = 'Onboarding - User With No Assets'
}

export enum MixPanelCounter {
  CreateOrderCount = 'Create Order Count'
}

export enum MixPanelOrderSide {
  Buy = 'Buy',
  Sell = 'Sell'
}

export enum MixPanelOrderType {
  Limit = 'Limit',
  Market = 'Market',
  StopLimit = 'Stop Limit',
  StopMarket = 'Stop Market'
}

export enum MixPanelConnectEntryPoint {
  Header = 'header',
  Referral = 'referral',
  TradePage = 'trade_page',
  Portfolio = 'portfolio',
  EmptyState = 'empty_state',
  StockTwits = 'stock_twits',
  ConnectPage = 'connect_page'
}
